var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us-bar-component",style:(_vm.bgStyle)},[_c('a',{staticClass:"contact-us-bar-item",style:(_vm.colorStyle),attrs:{"href":"tel:4008093885"}},[_vm._v("\n    电话咨询\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }